import React from 'react';
import { NotificationManager } from 'react-notifications';
import { _$, _addClass } from '../../../../controllers/dom';
import { locales } from '../../../../translations/locales';

const NewService = (props) => {
    const { locale, theme, ModuleRP } = props;

    const newService = () => {
        if (!_$('serviceName').value) {
            _addClass('serviceName', ['border', 'border-danger']);
            return NotificationManager.error(locales[locale].notifications.newGameNameInvalid);
        }
        ModuleRP.config.newService(_$('serviceName').value);
    };

    return (
        <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
            <div className="card container p-0 gameInformations mt-5">
                <h5 className="card-header bg-primary">
                    {locales[locale].config.addNewService}
                </h5>
                <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    <form onSubmit={(event) => {
                        event.preventDefault();
                        newService();
                    }}>
                        <div className='form-group'>
                            <label htmlFor='serviceName'>
                                {locales[locale].config.serviceName}
                                <span className='text-info m-1'>{locales[locale].config.required}</span>
                            </label>
                            <input
                                type='text'
                                id='serviceName'
                                className='form-control w-100'
                                placeholder={locales[locale].config.serviceName}
                            />
                        </div>
                    </form>
                </div>
                <div className={`card-footer bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    <button className='btn btn-primary float-right' id='btn-newService' onClick={newService}>{locales[locale].config.create}</button>
                </div>
            </div>
        </div>
    );
};

export default NewService;
